require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/angular-resource/index.js
// module id = 28
// module chunks = 0